export default "__VITE_ASSET__DzMTAhpK__"